import React from 'react';
import {useSelector, useDispatch} from 'react-redux';

import {ROUTE} from 'containers/App/constants';
import {selectTemplate} from 'store/selectors';

import {Title, Header, List} from 'components';
import i18n from 'i18next';
import {push} from 'connected-react-router';

function ChooseTemplate() {
  const {themes} = useSelector(selectTemplate);

  const dispatch = useDispatch();

  return (
    <>
      <div>
        <Header
          title={i18n.t('chooseTemplatePage.headerTitle')}
          className="pb-8"
        />
      </div>
      <div className="overflow-auto h-full-24">
        {themes?.map(({title, templates}) => {
          const items =
            templates &&
            templates.map(({icon, id, name, time, descriptions}) => ({
              icon,
              title: name,
              subtitle: time,
              descriptions,
              onClick: () =>
                dispatch(
                  push(`${ROUTE.Wisbit.Create}${id ? `?template=${id}` : ''}`)
                ),
            }));
          return (
            <div key={title}>
              <Title className="pt-5 pb-6">{title}</Title>
              <List className="w-1/2 pb-6 px-3">
                {items.map(item => (
                  <List.Item data={item} key={item.title} />
                ))}
              </List>
            </div>
          );
        })}
      </div>
    </>
  );
}

export default ChooseTemplate;
